import React,{useEffect, useState} from 'react';
import './chapters.css';
import chapter1 from'../../services/chapter1';
import chapter2 from'../../services/chapter2';
import chapter3 from'../../services/chapter3';

function Chapters({goBack, goPlay}) {
  const [step, setStep] = useState( localStorage.getItem('step') === null ? false : localStorage.getItem('step') == 0 ? false: true );
  const [white, setWhite] = useState(1);
  const [index, setIndex] = useState(14);
  useEffect(() => {
    changeWhite(true);
},[]);

  async function goToMenu(){
    await changeWhite();
    goBack();
  }

  function changeWhite(toLow){
    return new Promise((resolve, reject) => {
    if(toLow){
      var op=1;
      change(toLow);
    }else{
      var op=0;
      change();
    }
    function change(toLow){
    if(toLow){
      if(op>0){
        op-=0.03;
      setWhite(op);
      setTimeout(ChangetoLow, 10);
    }else{
      setIndex(0);
      resolve();
      return;
    }
  }else{
    if(op<1){
      op+=0.03;
    setWhite(op);
    setTimeout(change, 10);
  }else{
    resolve();
    return;
  }
  }

  function ChangetoLow(){
     change(true);
  }
  }
  });
  }
  async function goToChapter(e){
    setIndex(16)
      await changeWhite();
      if(e.target.id == 1){
          localStorage.setItem('step', 0);
    }else if(e.target.id == 2){
      localStorage.setItem('step', chapter1.length);
    }else if(e.target.id == 3){
      localStorage.setItem('step', chapter1.length+chapter2.length);
    }else if(e.target.id == 4){
      localStorage.setItem('step', chapter1.length+chapter2.length+chapter3.length);
    }
    localStorage.setItem('failedGame', 0);
        goPlay();
  }

return(
<div className='menu'>
<div className="arrow-1" onClick={goToMenu}>
    <div></div>
</div>
<div className='clickWrap' id='wrap' style={{opacity:white,zIndex:index}}></div>
<div className="chapters">
<div className="button1" onClick={goToChapter} id="1">CHAPTER 1</div>
<div className="button1" onClick={goToChapter} id="2">CHAPTER 2</div>
<div className="button1" onClick={goToChapter} id="3">CHAPTER 3</div>
<a href='https://almondraf.itch.io/nsfw-job-christmas-episode' target="_blank"><div className="button1">Christmas special<h6>Available on <span>Itch.io</span></h6></div></a>
<div className="button1" onClick={goToChapter} id="4">CHAPTER 4</div>
<a href='https://www.patreon.com/nsfwjob' target="_blank"><div className="button1">CHAPTER 5<h6>Available on <span>Patreon</span></h6></div></a>
<a href='https://www.patreon.com/nsfwjob' target="_blank"><div className="button1">CHAPTER 6<h6>Available on <span>Patreon</span></h6></div></a>
<div className="button1">COMING SOON..</div>
</div>
<p id="note">{step && "Choosing chapter will lose current progress"}</p>
</div>
);

}

export default Chapters;
